// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/**
 * fix-sprint-20261102-0448 Finding 7 — the ONE list of memory categories.
 *
 * The server's route list and both Forseti memory screens each kept their own
 * copy, and they drifted: the screens offered `auto_inferred`, which the edit
 * route refuses. Every reader takes its list from here.
 *
 * `MEMORY_CATEGORIES` is every category a stored row may carry, including
 * `auto_inferred` (written by the ingestion pipeline and swept by the memory
 * GC job), so it is what a list filter accepts. `CURATED_MEMORY_CATEGORIES`
 * is the subset a person may assign when editing a memory.
 */
export const CURATED_MEMORY_CATEGORIES = [
    'framework_interpretation',
    'process_preference',
    'escalation_threshold',
    'decision_context',
    'glossary_term',
];
export const MEMORY_CATEGORIES = [
    ...CURATED_MEMORY_CATEGORIES,
    'auto_inferred',
];
/** True when `value` is a category a person may assign. */
export function isCuratedMemoryCategory(value) {
    return CURATED_MEMORY_CATEGORIES.includes(value);
}
/** True when `value` is any category a stored memory may carry. */
export function isMemoryCategory(value) {
    return MEMORY_CATEGORIES.includes(value);
}
const _memoryCategoriesExhaustive = true;
void _memoryCategoriesExhaustive;
//# sourceMappingURL=forseti-memory.js.map